import { Button, TextArea, Toast } from 'antd-mobile';
import DOMPurify from 'dompurify';
import { useI18n } from 'i18n/useI18n';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { UserDataType } from 'services/apis/sys/user-api';
import FeedbackApi from 'services/apis/usr/feedback-api';
import { getItemWithExpiration } from 'utils/localStorageUtil';
import { scrollTop } from 'utils/screenUtil';

export default function UserFeedback(props: { userId: string }) {
  const { t } = useI18n();
  useEffect(() => {
    // scrollTop();
  }, []);
  const [content, setContent] = React.useState('');
  return (
    <div
      style={{
        lineHeight: 1.5,
      }}
    >
      <p
        style={{
          textAlign: 'left',
          fontSize: 16,
          fontWeight: 'bolder',
        }}
        className=" mt-2"
      >
        {t('feedback.index.863805-0')}
      </p>
      <p style={{ textAlign: 'left', margin: '10px 0px' }}>
        {t('feedback.index.863805-1')}
        {t('feedback.index.863805-2')}
      </p>
      <center className=" mx-8 mt-4">
        <TextArea
          placeholder={t('feedback.index.863805-3')}
          value={content}
          rows={8}
          showCount
          maxLength={100}
          style={{
            border: '1.5px solid #ee6666',
            borderRadius: 10,
            margin: '20px 0px',
            padding: 15,
            fontSize: 12,
          }}
          className=" bg-white/80 text-xs"
          onChange={(e) => {
            setContent(e);
          }}
        />
        <Button
          style={{
            background: '#FF7C9B',
            color: '#fff',
            width: '100%',
            margin: '10px 0px',
            padding: '10px 0px',
            fontSize: 14,
            borderRadius: 8,
          }}
          onClick={() => {
            // 对content转义, 防止XSS
            const cleanContent = DOMPurify.sanitize(`<img src="x" onerror="javascript:alert(document.cookie);">`);
            if (cleanContent == null || cleanContent === undefined || cleanContent.length === 0) {
              Toast.show(t('feedback.index.863805-4'));
              return;
            }
            const doFeedback = async (content: string, fkUserUuid: string) => {
              const result = await FeedbackApi.batchSave({
                feedbacks: [{ content, fkUserUuid }],
              });
              if (result.code === 0 && result.successful) {
                Toast.show(t('feedback.index.863805-5'));
              } else {
                Toast.show(t('feedback.index.863805-6'));
              }
              setContent('');
            };
            doFeedback(cleanContent, props.userId as string);
          }}
        >
          {t('feedback.index.863805-7')}
        </Button>
      </center>
    </div>
  );
}
